module.exports = __webpack_public_path__ + "img/OverseaMember45.1ef57a59.jpg";